import { parseBackUrl } from "../../core/utils";

class Controller {
  constructor(
    $rootScope,
    Events,
    $state,
    $stateParams,
    Login,
    Authentication,
    authService,
    $location,
    GoogleAuth
  ) {
    "ngInject";
    this.Login = Login;
    this.$state = $state;
    this.Events = Events;
    this.$location = $location;
    this.$stateParams = $stateParams;
    this.Authentication = Authentication;
    this.authService = authService;
    this.$rootScope = $rootScope;
    this.GoogleAuth = GoogleAuth;
    this.isLoggedin = false;
  }
  $onInit() {
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onSuccess = (response) => {
      const backToStr = this.$stateParams.back || "/bookings/";
      const backTo = parseBackUrl(backToStr);
      this.Authentication.authenticate(response);
      this.authService.loginConfirmed();
      this.$location.path(backTo.base).search(backTo.params);
      this.$rootScope.isLoggedin = true;
      this.isLoggedin = true;
      this.data = {};
    };
    const onError = (response) => {
      this.Events.emit(errorEvent, response.data);

      this.authService.loginCancelled();
      if (this.GoogleAuth.isSignedInWithGoogle()) {
        this.GoogleAuth.signOut();
      }
    };

    const onGoogleSignInSuccess = (signedUser) => {
      const idToken = signedUser.getAuthResponse().id_token;
      this.Login.signInWithGoogle({ idToken })
        .$promise.then(onSuccess)
        .catch(onError);
    };
    const onGoogleSignInFailed = async (err) => {
      await this.GoogleAuth.signOut();
      this.Events.emit(errorEvent, { message: err.reason });
    };

    this.submit = () => {
      this.Login.post(this.data)
        .$promise.then(onSuccess)
        .catch(onError)
        .finally(() => {
          this.processing = false;
        });
      this.processing = true;
    };

    this.GoogleAuth.renderSignInButton(
      onGoogleSignInSuccess,
      onGoogleSignInFailed
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/login/login.controller.js